import { render } from "./UploadPage.vue?vue&type=template&id=27b335a2&scoped=true"
import script from "./UploadPage.vue?vue&type=script&lang=js"
export * from "./UploadPage.vue?vue&type=script&lang=js"

import "./UploadPage.vue?vue&type=style&index=0&id=27b335a2&scoped=true&lang=css"

import exportComponent from "/home/acartia-ops/acartia/src/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b335a2"]])

export default __exports__